"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Menu = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Menu = props => {
  const {
    onClose,
    paperProps,
    children,
    ...rest
  } = props;
  return /*#__PURE__*/_react.default.createElement(_core.Popper, rest, /*#__PURE__*/_react.default.createElement(_core.Paper, paperProps, /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: onClose
  }, /*#__PURE__*/_react.default.createElement(_core.MenuList, null, children))));
};
exports.Menu = Menu;
Menu.propTypes = {
  /**
   * Conteúdo do menu
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Se TRUE, o componente fica visivel
   */
  open: _propTypes.default.bool,
  /**
   * Valor do conteudo (para casos de uso em select)
   */
  anchorEl: _propTypes.default.instanceOf(Element),
  /**
   * Local que Menu deve aparecer proximo ao elemento anchorEl
   */
  placement: _propTypes.default.string,
  /**
   * Ativa uma função quando usuário clica fora do menu
   */
  onClose: _propTypes.default.func.isRequired,
  /**
   * Props para componente Paper
   */
  paperProps: _propTypes.default.instanceOf(Object)
};
Menu.defaultProps = {
  open: false,
  anchorEl: null,
  placement: 'bottom',
  paperProps: {}
};
var _default = exports.default = Menu;